"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScheduledEmailManagement = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var model_1 = require("../../../model");
exports.useScheduledEmailManagement = function (props) {
    var onError = props.onError, onSuccess = props.onSuccess, loadScheduledMails = props.loadScheduledMails;
    var dashboardRef = model_1.useDashboardSelector(model_1.selectDashboardRef);
    var canManageScheduledMail = model_1.useDashboardSelector(model_1.selectCanManageScheduledMail);
    var effectiveBackend = sdk_ui_1.useBackendStrict();
    var effectiveWorkspace = sdk_ui_1.useWorkspaceStrict();
    var loadResultPromise = loadScheduledMails
        ? function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var scheduledEmails, users, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, effectiveBackend
                            .workspace(effectiveWorkspace)
                            .dashboards()
                            .getScheduledMailsForDashboard(dashboardRef, {
                            loadUserData: canManageScheduledMail,
                            createdByCurrentUser: !canManageScheduledMail,
                        })];
                    case 1:
                        scheduledEmails = _b.sent();
                        if (!canManageScheduledMail) return [3 /*break*/, 3];
                        return [4 /*yield*/, effectiveBackend.workspace(effectiveWorkspace).users().queryAll()];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        users = _a;
                        return [2 /*return*/, { scheduledEmails: scheduledEmails.reverse(), users: users }];
                }
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({ promise: loadResultPromise, onError: onError, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
        canManageScheduledMail,
        dashboardRef,
        loadScheduledMails,
    ]);
};
//# sourceMappingURL=useScheduledEmailManagement.js.map